var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-callout",class:_vm.type},[_c('font-awesome-icon',{staticClass:"base-callout-icon",attrs:{"icon":['fas', _vm.icon]}}),_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }